import styled from "@emotion/styled";
import {Container } from "@mui/material";

export const StyledContainer = styled(Container)({
  backgroundColor: '#F5F5F5',
  minHeight: "100vh",
  height: "100%",
});